import { render, staticRenderFns } from "./sudentMesseger.vue?vue&type=template&id=4e36ae29&"
import script from "./sudentMesseger.vue?vue&type=script&lang=ts&"
export * from "./sudentMesseger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports